import React from 'react';
import { useTeamVisualResolver } from '../../hooks/useTeamVisualResolver';
import TeamVisualBadge from './TeamVisualBadge';

export type TeamMatchupBadgeProps = {
  label: string;
  size?: 'sm' | 'md';
  side?: 'away' | 'home';
  schoolId?: string | null;
};

const TeamMatchupBadge: React.FC<TeamMatchupBadgeProps> = ({
  label,
  size = 'md',
  side,
  schoolId,
}) => {
  const resolveVisual = useTeamVisualResolver();
  const visual = resolveVisual({ label, schoolId });

  return (
    <div
      className="flex flex-col items-center gap-1 min-w-[4.5rem]"
      data-testid="team-matchup-badge"
      data-side={side}
      data-school-id={visual.schoolId ?? undefined}
    >
      <TeamVisualBadge visual={visual} size={size} side={side} />
      <span className="text-[11px] font-medium text-secondary-200 text-center line-clamp-2">
        {visual.displayName}
      </span>
    </div>
  );
};

export default TeamMatchupBadge;
